import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetSpecificJustificationsforTransfer = createAsyncThunk(
  "GetSpecificJustificationsforTransfer/GetSpecificJustificationsforTransfer",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/JustificationsforTransfer/GetSpecificJustificationsforTransfer",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const DeleteJustificationsforTransfer = createAsyncThunk(
  "DeleteJustificationsforTransfer/DeleteJustificationsforTransfer",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/JustificationsforTransfer/DeleteJustificationsforTransfer",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const EditJustificationsforTransfer = createAsyncThunk(
  "EditJustificationsforTransfer/EditJustificationsforTransfer",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/JustificationsforTransfer/EditJustificationsforTransfer",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AddJustificationsforTransfer = createAsyncThunk(
  "AddJustificationsforTransfer/AddJustificationsforTransfer",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/JustificationsforTransfer/AddJustificationsforTransfer",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetSpecificJustificationsforTransferByProjectModificationRequestsId =
  createAsyncThunk(
    "AddJustificationsforTransfer/GetSpecificJustificationsforTransferByProjectModificationRequestsId",
    async (param, { rejectWithValue }) => {
      try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
          "api/JustificationsforTransfer/GetSpecificJustificationsforTransferByProjectModificationRequestsId",
          param
        );

        // Extract data from the response object
        const data = response.data.result; // Assuming response has a "data" field

        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

const JustificationsforTransfer = createSlice({
  name: "JustificationsforTransfer",
  initialState: {
    JustificationsforTransfer: {},
    loadingJustificationsforTransfer: false,
    errorJustificationsforTransfer: null,

    AddJustificationsforTransfer: {},
    loadingAddJustificationsforTransfer: false,
    errorAddJustificationsforTransfer: null,

    UpdateJustificationsforTransfer: {},
    loadingUpdateJustificationsforTransfer: false,
    errorUpdateJustificationsforTransfer: null,

    DeleteJustificationsforTransfer: {},
    loadingDeleteJustificationsforTransfer: false,
    errorDeleteJustificationsforTransfer: null,

    GetSpecificJustificationsforTransferByProjectModificationRequests: {},
    loadingGetSpecificJustificationsforTransferByProjectModificationRequests: false,
    errorGetSpecificJustificationsforTransferByProjectModificationRequests:
      null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(
        GetSpecificJustificationsforTransfer.pending,
        (state, action) => {
          state.loadingJustificationsforTransfer = true;
          state.JustificationsforTransfer = action.payload;
          state.errorJustificationsforTransfer = null;
        }
      )
      .addCase(
        GetSpecificJustificationsforTransfer.fulfilled,
        (state, action) => {
          state.loadingJustificationsforTransfer = false;
          state.JustificationsforTransfer = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetSpecificJustificationsforTransfer.rejected,
        (state, action) => {
          state.loadingJustificationsforTransfer = false;
          state.errorJustificationsforTransfer = action.payload;
        }
      )

      .addCase(DeleteJustificationsforTransfer.pending, (state, action) => {
        state.loadingDeleteJustificationsforTransfer = true;
        state.DeleteJustificationsforTransfer = action.payload;
        state.errorJustificationsforTransfer = null;
      })
      .addCase(DeleteJustificationsforTransfer.fulfilled, (state, action) => {
        state.loadingJustificationsforTransfer = false;
        state.DeleteJustificationsforTransfer = action.payload; // Assuming payload has the desired data
      })
      .addCase(DeleteJustificationsforTransfer.rejected, (state, action) => {
        state.loadingDeleteJustificationsforTransfer = false;
        state.errorDeleteJustificationsforTransfer = action.payload;
      })

      .addCase(EditJustificationsforTransfer.pending, (state, action) => {
        state.loadingUpdateJustificationsforTransfer = true;
        state.JustificationsforTransfer = action.payload;
        state.errorUpdateJustificationsforTransfer = null;
      })
      .addCase(EditJustificationsforTransfer.fulfilled, (state, action) => {
        state.loadingUpdateJustificationsforTransfer = false;
        state.UpdateJustificationsforTransfer = action.payload; // Assuming payload has the desired data
      })
      .addCase(EditJustificationsforTransfer.rejected, (state, action) => {
        state.loadingUpdateJustificationsforTransfer = false;
        state.errorUpdateJustificationsforTransfer = action.payload;
      })

      .addCase(AddJustificationsforTransfer.pending, (state, action) => {
        state.loadingAddJustificationsforTransfer = true;
        state.AddJustificationsforTransfer = action.payload;
        state.errorAddJustificationsforTransfer = null;
      })
      .addCase(AddJustificationsforTransfer.fulfilled, (state, action) => {
        state.loadingAddJustificationsforTransfer = false;
        state.AddJustificationsforTransfer = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddJustificationsforTransfer.rejected, (state, action) => {
        state.loadingAddJustificationsforTransfer = false;
        state.errorAddJustificationsforTransfer = action.payload;
      })

      .addCase(GetSpecificJustificationsforTransferByProjectModificationRequestsId.pending, (state, action) => {
        state.loadingGetSpecificJustificationsforTransferByProjectModificationRequests = true;
        state.GetSpecificJustificationsforTransferByProjectModificationRequests = action.payload;
        state.errorAddJustificationsforTransfer = null;
      })
      .addCase(GetSpecificJustificationsforTransferByProjectModificationRequestsId.fulfilled, (state, action) => {
        state.loadingGetSpecificJustificationsforTransferByProjectModificationRequests = false;
        state.GetSpecificJustificationsforTransferByProjectModificationRequests = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetSpecificJustificationsforTransferByProjectModificationRequestsId.rejected, (state, action) => {
        state.loadingGetSpecificJustificationsforTransferByProjectModificationRequests = false;
        state.errorGetSpecificJustificationsforTransferByProjectModificationRequests = action.payload;
      });
  },
});

export default JustificationsforTransfer.reducer;
